import { customElement } from 'lit/decorators.js';
import { localized } from "@lit/localize";
import { UsosBox } from "./usos-box";
import style from './error-box.scss';

/**
 * Error box information. Registers as alert for accessibility tools.
 */

@customElement('error-box')
@localized()
export class ErrorBox extends UsosBox {
    static override styles = [...UsosBox.styles, style];

    constructor() {
        super();
        const internals = this.attachInternals();
        internals.role = 'alert';
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'error-box': ErrorBox
    }
}
